interface ResampleColors {
  top?: string;
  bottom?: string;
}

/**
 * Force Safari 26+ to resample its toolbar tint by briefly inserting
 * fixed sentinel elements at the viewport edges. The sentinels sit at
 * max z-index so they override any cached tint, then a double-rAF
 * removal forces Safari to resample from the real DOM.
 *
 * Pass a color close to the expected result to avoid a visible flash.
 */
export function resampleToolbar({ top, bottom }: ResampleColors): void {
  const sentinels: HTMLElement[] = [];
  if (top) sentinels.push(createSentinel("top", top));
  if (bottom) sentinels.push(createSentinel("bottom", bottom));
  if (sentinels.length === 0) return;

  for (const el of sentinels) document.body.appendChild(el);
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      for (const el of sentinels) el.remove();
    });
  });
}

function createSentinel(edge: "top" | "bottom", color: string): HTMLElement {
  const el = document.createElement("div");
  el.style.position = "fixed";
  el.style[edge] = "0";
  el.style.left = "0";
  el.style.width = "100%";
  el.style.height = "6px";
  el.style.zIndex = "2147483647";
  el.style.pointerEvents = "none";
  el.style.backgroundColor = color;
  return el;
}
